import { useEffect, useState } from 'react';

import useService from '@/lib/hooks/useService';

const eventList = ['click', 'touchend', 'scroll', 'touchmove', 'keydown'];

export const useStandby = () => {
  const [isStandby, setIsStandby] = useState(false);
  const [displayTime, setDisplayTime] = useState(new Date());
  const [showStandbyTime, setShowStandbyTime] = useState(new Date().getTime());

  const [communityData] = useService({
    collectionName: 'communityData',
    query: {
      $select: ['screenStandby'],
    },
  });

  const standbyAfterMilliseconds =
    communityData && communityData[0]
      ? communityData[0].screenStandby.afterMilliseconds
      : undefined;

  const canActiveScreenStandby =
    standbyAfterMilliseconds && communityData && communityData[0]
      ? communityData[0].screenStandby.isActive
      : false;

  useEffect(() => {
    if (communityData[0]?.screenStandby?.afterMilliseconds) {
      setShowStandbyTime((prevTime) => prevTime + standbyAfterMilliseconds);
    }
  }, [communityData, standbyAfterMilliseconds]);

  useEffect(() => {
    if (!canActiveScreenStandby) {
      return;
    }

    const userActivityCheckInterval = setInterval(() => {
      const now = new Date().getTime();
      if (now >= showStandbyTime) {
        setIsStandby(true);
      }
    }, 1000);

    return () => clearInterval(userActivityCheckInterval);
  }, [canActiveScreenStandby, showStandbyTime]);

  useEffect(() => {
    if (!canActiveScreenStandby) {
      return;
    }

    const displayTimeInterval = setInterval(() => {
      if (isStandby) {
        setDisplayTime(new Date());
      }
    }, 1000);

    return () => clearInterval(displayTimeInterval);
  }, [canActiveScreenStandby, isStandby]);

  const screenWakeUp = () => {
    setShowStandbyTime(new Date().getTime() + standbyAfterMilliseconds);
    if (isStandby) {
      setIsStandby(false);
    }
  };

  useEffect(() => {
    if (!canActiveScreenStandby) {
      return;
    }

    eventList.forEach((event) => {
      window.addEventListener(event, () =>
        setShowStandbyTime(new Date().getTime() + standbyAfterMilliseconds)
      );
    });

    return () => {
      eventList.forEach((event) => {
        window.removeEventListener(event, () =>
          setShowStandbyTime(new Date().getTime() + standbyAfterMilliseconds)
        );
      });
    };
  }, [canActiveScreenStandby, standbyAfterMilliseconds]);

  return [
    canActiveScreenStandby,
    isStandby,
    displayTime,
    screenWakeUp,
  ] as const;
};
